import type { useFollowsQuery } from '../../hooks/use-investor-assistant'

type Follow = NonNullable<ReturnType<typeof useFollowsQuery>['data']>['data'][number]

export type SortKey = 'added' | 'name' | 'round' | 'updates' | 'status'

const STATUS_RANK: Record<Follow['state'], number> = {
  CONDITION_MET: 0,
  ACTIVE: 1,
  WAITING_CHECK: 2,
  WAITING_PLACE: 3,
  ENDED_BY_FOUNDER: 4,
  NONE: 5,
}

export function compareBy(key: SortKey, a: Follow, b: Follow): number {
  switch (key) {
    case 'added':
      return new Date(a.followedAt).getTime() - new Date(b.followedAt).getTime()
    case 'name':
      return a.startupName.localeCompare(b.startupName)
    case 'round':
      return (a.round.amount ?? 0) - (b.round.amount ?? 0)
    case 'updates':
      return (
        new Date(a.founderUpdates.latestAt ?? 0).getTime() -
        new Date(b.founderUpdates.latestAt ?? 0).getTime()
      )
    case 'status':
      return STATUS_RANK[a.state] - STATUS_RANK[b.state]
  }
}
